/* TRIO – Bannière animée + parcours */
(function () {
  'use strict';
  if (window.__trioWow) return;
  window.__trioWow = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };

  function count(el, delay) {
    var to = parseFloat(el.dataset.to), from = parseFloat(el.dataset.from || 0);
    var num = el.querySelector('[data-n]');
    if (reduce) { num.textContent = to; return; }
    num.textContent = from;
    setTimeout(function () {
      var t0 = performance.now(), dur = 1600;
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        num.textContent = Math.round(from + (to - from) * ease(p));
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }, delay);
  }

  function hero(sec) {
    var stats = sec.querySelectorAll('[data-tw-count]');
    stats.forEach(function (s, i) { count(s, 1000 + i * 120); });

    var hs = sec.querySelectorAll('.tw-hs'), k = 0, timer;
    function cycle() { hs.forEach(function (h, j) { h.classList.toggle('is-on', j === k); }); k = (k + 1) % hs.length; }
    if (hs.length) setTimeout(function () { cycle(); timer = setInterval(cycle, 2400); }, reduce ? 0 : 2300);

    if (reduce) return;
    var word = sec.querySelector('.tw-word'), prods = sec.querySelectorAll('[data-tw-layer]'), chars = sec.querySelectorAll('.tw-word > span');
    var mx = 0, my = 0, tx = 0, ty = 0, sp = 0, raf;
    sec.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = sec.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5;
    });
    sec.addEventListener('pointerleave', function () { mx = my = 0; });
    function frame() {
      tx += (mx - tx) * .08; ty += (my - ty) * .08;
      var r = sec.getBoundingClientRect();
      sp = Math.min(1, Math.max(0, -r.top / (r.height * .9)));
      var mid = (chars.length - 1) / 2;
      chars.forEach(function (c, i) { c.style.transform = 'translateX(' + ((i - mid) * sp * 7) + 'vw)'; });
      word.style.transform = 'translate3d(' + (-tx * 26) + 'px,' + (-ty * 14 + sp * 60) + 'px,0)';
      var pt = 'translate(-50%,-50%) translate3d(' + (tx * 18) + 'px,' + (ty * 10 - sp * 40) + 'px,0) scale(' + (1 + sp * .1) + ')';
      prods.forEach(function (el) { el.style.transform = pt; });
      raf = requestAnimationFrame(frame);
    }
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { cancelAnimationFrame(raf); raf = requestAnimationFrame(frame); } else cancelAnimationFrame(raf);
    });
    io.observe(sec);
  }

  function journey(sec) {
    var steps = sec.querySelectorAll('.tw-step'), imgs = sec.querySelectorAll('.tw-art__img'), bars = sec.querySelectorAll('.tw-prog i');
    var big = sec.querySelector('[data-tw-big]'), unit = sec.querySelector('[data-tw-unit]');
    var n = steps.length, cur = -1, shown = null, anim;
    function setBig(to, u) {
      unit.textContent = u;
      var from = shown == null ? to : shown; shown = to;
      cancelAnimationFrame(anim);
      if (reduce) { big.textContent = to; return; }
      var t0 = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - t0) / 700);
        big.textContent = Math.round(from + (to - from) * ease(p));
        if (p < 1) anim = requestAnimationFrame(step);
      })(t0);
    }
    function go(i) {
      if (i === cur) return; cur = i;
      steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
      imgs.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
      setBig(parseFloat(steps[i].dataset.value), steps[i].dataset.unit);
    }
    function onScroll() {
      var r = sec.getBoundingClientRect(), total = sec.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      var f = p * n;
      bars.forEach(function (b, j) { b.style.setProperty('--p', Math.min(1, Math.max(0, f - j))); });
      go(Math.min(n - 1, Math.floor(f)));
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-tw-hero]').forEach(hero);
    root.querySelectorAll('[data-tw-journey]').forEach(journey);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
